module.exports = __webpack_public_path__ + "static/img/sub_page_banner_1.b2b9213.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sub_page_banner_1.jpg
// module id = AVOc
// module chunks = 0